import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { NewsCard } from "@bluframe/mightychroma-mightytool-ui";
import config from "config/site";
import Actions from "./Actions";
import { Row, Wrapper } from "./styled";
const EightLeggedFreakNews = ({ newsCards }) => (_jsx(Wrapper, { children: config.news.map((item) => (_jsx(Row, { children: item.rows.map((row) => {
            const newsCard = newsCards[row.serviceName];
            return (_createElement(NewsCard, { ...newsCard, actions: _jsx(Actions, { serviceName: row.serviceName }), key: row.serviceName, serviceName: row.serviceName }));
        }) }, item.id))) }));
export default EightLeggedFreakNews;
